module.exports = __webpack_public_path__ + "5f55095908a9a7d289199841d8e6de1f.svg";